import React from 'react';
import HrnbCard from './HrnbCard';
import HrnbButton from './HrnbButton';
import '../../css/components/controls/HrnbErrorBoundary.css';

/**
 * ErrorBoundary — ловит ошибки рендера в дочерних компонентах
 * и показывает красивый fallback вместо белого экрана.
 */
export default class HrnbErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('[HrnbErrorBoundary] Caught error:', error, errorInfo);
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            const fallback = this.props.fallback || (
                <HrnbCard className="hrnb-error-boundary-card">
                    <div className="hrnb-error-boundary-content">
                        <span className="hrnb-error-boundary-icon">⚠️</span>
                        <h3 className="hrnb-error-boundary-title">
                            {this.props.title || 'Что-то пошло не так'}
                        </h3>
                        <p className="hrnb-error-boundary-message">
                            {this.props.message || 'Произошла ошибка при отображении этого раздела.'}
                        </p>
                        <HrnbButton variant="outline" size="sm" onClick={this.handleRetry}>
                            Попробовать снова
                        </HrnbButton>
                    </div>
                </HrnbCard>
            );
            return fallback;
        }

        return this.props.children;
    }
}